import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { DataBaseProvider } from '../../providers/data-base/data-base';
import * as moment from 'moment';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
/**
 * In this page the daily activites of the farnchasie is captured
 * The tenat will have to enter the daily activites to the system
 * he can edit the details and can commit to the end of day.
 */

@IonicPage()
@Component({
  selector: 'page-daily-activity',
  templateUrl: 'daily-activity.html',
})
export class DailyActivityPage {
  items: any[];
  filteredItems: any[];
  userKey: string;
  date: any;
  isAdmin: boolean;
  showEditButtons: boolean;
  constructor(public navCtrl: NavController,
    public $db: DataBaseProvider,
    public navParams: NavParams,
    public alertController: AlertController,
    private $auth: AuthServiceProvider) {
    this.items = [];
    this.userKey = this.navParams.get('userKey');
    this.getItems();
    this.date = moment().format("YYYY-MM-DD");
  }

  getItems() {
    this.$db.getTheListOfLogs(this.userKey).subscribe((data: any[]) => {
      this.items = data;
      this.filterDate();
      this.sortRecords();
    });
  }

  sortRecords() {
    this.filteredItems = this.filteredItems.sort((a: any, b: any) => {
      if (a.logNumber < b.logNumber) { return -1; }
      if (a.logNumber > b.logNumber) { return 1; }
      return 0;
    });
  }

  filterDate() {
    this.filteredItems = this.items.filter(data => data.date === this.date);
  }

  ionViewDidLoad() {
    this.isAdmin = false;
    this.showEditButtons = true;
    this.$auth.isAdmin().subscribe(state => {
      this.isAdmin = state;
      // this.isAdmin = false;
    })
  }

  dateChange(event) {
    this.date = event;
    this.filterDate();
    this.sortRecords();
    this.showButtons();
  }



  addRecord() {
    this.filteredItems.push({});
  }

  upDateRecords() {
    let index = 0;
    this.filteredItems.forEach(item => {
      index++;
      item.ownerKey = this.userKey;
      if (item.key) {
        // update the record
        this.$db.updateActivityLog(item);
        if (index === this.items.length) this.showSavedMessage();
      } else {
        // add a new record
        if (item.logNumber) {
          // insert date information for new records
          // change needed the information should be fetched from the date picker
          item.date = this.date;
          this.$db.insertActivityLog(item);
        }
        if (index === this.items.length) this.showSavedMessage();
      }
    })
  }

  showSavedMessage() {
    this.alertController.create(
      {
        title: 'Success',
        message: 'Logs Saved',
        buttons: ['OK']
      }
    ).present()
  }

  /**
   * Check the permission for a record 
   * can be edited 
   * @param record 
   */
  isEditDisabled(record?): boolean {
    // Rule : let the users can edit as they like for the some time 
    // business rules disabled 
    return false;
    // // if the user is an Admin all the forms are enabled
    // if (this.isAdmin) { return false }
    // // if the date is before today then forms are disabled
    // if (moment().diff(moment(record.date, 'YYYY-MM-DD'), 'days') > 0) { return true }
    // return false;
  }

  // show the buttons to add and edit record
  showButtons() {
    this.showEditButtons = true;
    // rules suppressed
    // this.showEditButtons = this.isAdmin ? true :
    //   moment().diff(moment(this.date, 'YYYY-MM-DD'), 'days') > 0 ? false : true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-activity/daily-activity.ts